import axios from 'axios'

export const GET_SINGLE_PRODUCT = async (productID) =>
  await axios.get(
    `${process.env.REACT_APP_BASE_URL}/api/products/getSingleProduct/${productID}`
  )
